<template>
  <div class="sh_ai_history_chat">
    <div class="sh_new_chat">
      <el-button size="small" @click="onAddChat" type="success">
        <i class="el-icon-plus"></i>
        <span>开启新回话</span>
      </el-button>
    </div>
    <div class="sh_chat_list">
      <el-scrollbar ref="scrollbar" style="height: 100%">
        <template v-for="(group, groupName) in groupedChatList">
          <div v-if="group.length > 0" class="chat-group" :key="groupName">
            <div class="group-title">{{ groupName }}</div>
            <div v-for="(item, i) in group" :key="item.id">
              <slot :chatData="item" :index="i">
                <div class="sh_ai_history_chat_item" :class="[item.id === activeChatId ? 'is_ai_acitve' : '']">
                  <div class="sh_ai_chat_title_container">
                    <el-tooltip v-if="showPopovers[item.id]" placement="top" :content="item[chatTitleKey]">
                      <div class="sh_ai_chat_title" @click.stop="onClick(item)" :ref="setTitleRef(item.id)">
                        {{ item[chatTitleKey] }}
                      </div>
                    </el-tooltip>
                    <div v-else class="sh_ai_chat_title" @click.stop="onClick(item)" :ref="setTitleRef(item.id)">
                      {{ item[chatTitleKey] }}
                    </div>
                  </div>
                  <div class="sh_ai_chat_operate">
                    <el-tooltip placement="top" content="删除">
                      <span style="color: red"><i class="el-icon-delete-solid" @click="onDelete(item)"></i></span>
                    </el-tooltip>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </template>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShAiHistoryChat',
  props: {
    historyChat: {
      type: Array,
      default: () => []
    },
    activeChatId: {
      type: [String, Number],
      default: null
    },
    chatTitleKey: {
      type: String,
      default: 'name'
    }
  },
  data() {
    return {
      nowActiveChatId: null,
      showPopovers: {}
    }
  },
  computed: {
    groupedChatList() {
      const now = new Date()
      const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const startOfYesterday = new Date(startOfToday.getTime() - 24 * 60 * 60 * 1000)
      const startOf7DaysAgo = new Date(startOfToday.getTime() - 7 * 24 * 60 * 60 * 1000)
      const startOf30DaysAgo = new Date(startOfToday.getTime() - 30 * 24 * 60 * 60 * 1000)

      const groups = {
        今天: [],
        昨天: [],
        '7天内': [],
        '30天内': [],
        '30天前': []
      }

      this.historyChat.forEach(chat => {
        const createTime = new Date(chat.createTime)
        if (createTime >= startOfToday) {
          groups['今天'].push(chat)
        } else if (createTime >= startOfYesterday && createTime < startOfToday) {
          groups['昨天'].push(chat)
        } else if (createTime >= startOf7DaysAgo && createTime < startOfYesterday) {
          groups['7天内'].push(chat)
        } else if (createTime >= startOf30DaysAgo && createTime < startOf7DaysAgo) {
          groups['30天内'].push(chat)
        } else {
          groups['30天前'].push(chat)
        }
      })

      Object.keys(groups).forEach(key => {
        groups[key].sort((a, b) => new Date(b.createTime) - new Date(a.createTime))
      })

      return groups
    }
  },
  mounted() {
    this.updateAfterDOMReady()
  },
  watch: {
    historyChat: {
      handler() {
        this.updateAfterDOMReady()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateAfterDOMReady() {
      this.$nextTick(() => {
        this.checkOverflow()
      })
    },
    onAddChat() {
      this.$emit('new-chat')
      //   this.updateAfterDOMReady()
    },
    onClick(e) {
      this.$emit('update:activeChatId', e.id)
      this.$emit('select-chat', e)
      //   this.updateAfterDOMReady()
    },
    onDelete(e) {
      this.$emit('delete-chat', e)
      //   this.updateAfterDOMReady()
    },
    setTitleRef(id) {
      return el => {
        if (!this.$refs.titleRefs) {
          this.$refs.titleRefs = {}
        }
        if (el) {
          this.$refs.titleRefs[id] = el
        }
      }
    },
    checkOverflow() {
      if (!this.$refs.titleRefs) return
      this.historyChat.forEach(item => {
        const el = this.$refs.titleRefs[item.id]
        if (!el) return
        const isOverflow = el.scrollWidth > el.clientWidth
        if (this.showPopovers[item.id] !== isOverflow) {
          this.$set(this.showPopovers, item.id, isOverflow)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
